export default "__VITE_ASSET__BiYhq$VN__"